import { ButtonHTMLAttributes } from "react";

type ButtonSize = "sm" | "md" | "icon";
type ButtonVariant = "default" | "outline" | "ghost";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    size?: ButtonSize;
    variant?: ButtonVariant;
    className?: string;
};

const sizeStyles: Record<ButtonSize, string> = {
    sm: "py-2 px-5 text-sm",
    md: "py-2.5 px-6",
    icon: "p-2.5",
};

const variantStyles: Record<ButtonVariant, string> = {
    default: "",
    outline: "border bg-transparent hover:bg-white hover:text-black",
    ghost: "hover:bg-white/10",
};

export default function Button({
    size = "md",
    variant = "default",
    className = "",
    type = "button",
    children,
    ...props
}: ButtonProps) {
    return (
        <button
            type={type}
            className={`group inline-flex items-center gap-2 rounded-xl transition-all active:scale-95 ${sizeStyles[size]} ${variantStyles[variant]} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}
